import { EmptyState, Panel, Skeleton } from '../../components/ui';
import { PageHeader } from '../../layouts/Shells';
import { useSalesAccess } from '../tracker/hooks';
import { DealsMonitoringView } from './DealsMonitoringView';

/**
 * Deals as a destination of its own.
 *
 * It lived as a tab inside the Tracker, which meant two steps to reach
 * something people open directly and a URL that could not be shared. The view
 * itself is unchanged; this is the shell around it.
 *
 * Two gates, matching the module gate in the database rather than replacing
 * it: the sales_members list says whether this person is on the sales team,
 * and the permissions matrix says whether they may reach Deals at all. The
 * server enforces both regardless — this only decides what to render instead
 * of a wall of failed queries.
 */

const TITLE = 'Deals';
// The description retired with the move to the top bar: "named accounts, their
// next action and who is following up" is the four columns of the board below
// it, read aloud.

export function DealsPage() {
  const accessQuery = useSalesAccess();

  if (accessQuery.isPending) {
    return (
      <>
        <PageHeader title={TITLE} topbar />
        <Panel>
          <Skeleton lines={3} label="Checking access" />
        </Panel>
      </>
    );
  }

  if (accessQuery.data !== true) {
    return (
      <>
        <PageHeader title={TITLE} topbar />
        <Panel>
          <EmptyState
            title="Sales team only"
            description="Deals is limited to the sales team. Ask an admin if you need access."
          />
        </Panel>
      </>
    );
  }

  return (
    <>
      <PageHeader title={TITLE} topbar />
      <DealsMonitoringView />
    </>
  );
}
